import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/products', label: 'Products' },
    { path: '/logistics', label: 'Logistics' },
    { path: '/contact', label: 'Contact' },
  ];

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-800/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" onClick={handleNavClick} className="flex items-center space-x-3 group">
            <img 
              src="https://static.readdy.ai/image/14febd11ed764a2e4131edc63c3ba26f/1d63319f2e89e7422c7ba7489b97cad7.webp" 
              alt="Lynora Logo" 
              className="h-14 w-auto transform group-hover:scale-105 transition-transform duration-300"
            />
            <span className="text-2xl font-bold text-white" style={{ textShadow: '1px 1px 0 #4a5568, -1px -1px 0 #4a5568, 1px -1px 0 #4a5568, -1px 1px 0 #4a5568' }}>
              LYNORA
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={handleNavClick}
                className={`text-sm font-medium transition-all duration-300 hover:text-blue-400 relative group whitespace-nowrap uppercase ${
                  location.pathname === link.path
                    ? 'text-blue-400'
                    : 'text-white'
                }`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full ${
                    location.pathname === link.path ? 'w-full' : ''
                  }`}
                ></span>
              </Link>
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-blue-400 transition-colors duration-300"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-slate-800 rounded-lg shadow-xl">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  handleNavClick();
                }}
                className={`block px-6 py-3 text-sm font-medium transition-colors duration-300 hover:bg-slate-700 hover:text-blue-400 uppercase ${
                  location.pathname === link.path ? 'text-blue-400 bg-slate-700' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
